import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { Connector } from '@/types'

interface ConnectionSelectProps {
  readonly id: string
  readonly connections: readonly Connector[]
  readonly value: string
  readonly onChange: (connectorId: string) => void
  readonly label?: string
  readonly testId?: string
  readonly disabled?: boolean
}

export function ConnectionSelect({
  id,
  connections,
  value,
  onChange,
  label = 'Connection',
  testId = 'connection-select',
  disabled,
}: ConnectionSelectProps) {
  if (connections.length < 2) return null

  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-sm font-medium">
        {label}
      </label>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger id={id} data-testid={testId}>
          <SelectValue placeholder="Select a connection" />
        </SelectTrigger>
        <SelectContent>
          {connections.map(connection => (
            <SelectItem key={connection.id} value={connection.id}>
              {connection.connectionName || connection.type}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
